import { render, staticRenderFns } from "./Assignments.vue?vue&type=template&id=71cf341b"
import script from "./Assignments.vue?vue&type=script&lang=ts"
export * from "./Assignments.vue?vue&type=script&lang=ts"
import style0 from "./Assignments.vue?vue&type=style&index=0&id=71cf341b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports